import request from '@/utils/request'

export function getAddressList(params) {
    return request({
        url: '/userAddress/list',
        method: 'get',
        params
    })
}

export function upsertAddress(data) {
    return request({
        url: '/userAddress/upsert',
        method: 'post',
        data
    })
}
